import config from '../config'
import http from '../http'
import {
  getHomeData as mockGetHomeData,
  getBoundaryData as mockGetBoundaryData,
  getDatabaseData as mockGetDatabaseData,
  getReportData as mockGetReportData,
  getEvaluationData as mockGetEvaluationData
} from '@/mock/carbonAccounting'

export function getHomeData(params) {
  if (config.useMock) {
    return mockGetHomeData(params)
  }
  return http.get(`${config.api}/carbon/accounting/home`, { params }).then(res => res.data)
}

export function getBoundaryData(params) {
  if (config.useMock) {
    return mockGetBoundaryData(params)
  }
  return http.get(`${config.api}/carbon/accounting/boundary`, { params }).then(res => res.data)
}

export function getDatabaseData(params) {
  if (config.useMock) {
    return mockGetDatabaseData(params)
  }
  return http.get(`${config.api}/carbon/accounting/database`, { params }).then(res => res.data)
}

export function getReportData(params) {
  if (config.useMock) {
    return mockGetReportData(params)
  }
  return http.get(`${config.api}/carbon/accounting/report`, { params }).then(res => res.data)
}

export function getEvaluationData(params) {
  if (config.useMock) {
    return mockGetEvaluationData(params)
  }
  return http.get(`${config.api}/carbon/accounting/evaluation`, { params }).then(res => res.data)
}
